import React from 'react'

const Manual_inventario_categoria_producto_dos = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          Inventario - Categoría de Producto
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          La guía explica cómo crear una categoría de producto en un sistema de inventario, facilitando su organización y mejorando la gestión y eficiencia operativa.
        </p>
        <iframe
          src="https://scribehow.com/embed/Inventario__Categoria_de_Producto__TqTV-7xoR4-EwlVTR3Olpw?as=scrollable"
          className="scribe-iframe-general-46"
          width="100%"
          height="3900"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_inventario_categoria_producto_dos